import { render, staticRenderFns } from "./FooterC.vue?vue&type=template&id=a9fe4b64&scoped=true&"
import script from "./FooterC.vue?vue&type=script&lang=ts&"
export * from "./FooterC.vue?vue&type=script&lang=ts&"
import style0 from "./FooterC.vue?vue&type=style&index=0&id=a9fe4b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fe4b64",
  null
  
)

export default component.exports